import { RouterCore } from './routerCore'
import { i18n } from '../../i18n'
import jsActionApi from '../../jsActions/index'


export const RouterModule = {
  async config(Vue, { router, store, basePath }, ) {
    let appModel =  store.getters.appModel
    // Получение страниц со всех модулей
    let pages = appModel.Modules.DefaultModuleImpl.Pages
    if (appModel.UserModel?.Modules?.DefaultModuleImpl?.Pages) {
      pages = [...pages, ...appModel.UserModel.Modules.DefaultModuleImpl.Pages]
      pages = mergePages(pages, appModel.UserModel.Modules.DefaultModuleImpl.Pages)
    }

    router.addRoutes([])

    Vue.$routerCore = Vue.prototype.$routerCore = new RouterCore(router, appModel, Vue.$authCore, store)
    jsActionApi.install(Vue, { dependencies: { store } })

    // функция которая получает делает из страниц руты, а также проверяет отключены ли они
    async function getRoutes() {
      let correctRoutes = []
      let routesWithJSAction = []

      for (let pagesIndex = 0; pagesIndex < pages.length; pagesIndex++) {
        const currentPage = pages[pagesIndex]

        const currentPageTemplate = {
          path: (basePath || '') + (currentPage.Path || `/${currentPage.$ID}`),
          name: currentPage.$ID,
          component: Vue.component('PageComponent')
        }

        if (!currentPage?.Disabled?.JsAction) {
          correctRoutes.push(currentPageTemplate)
          continue
        }
        
        routesWithJSAction.push({...currentPageTemplate, Disabled: currentPage.Disabled, $ID: currentPage.$ID })
      }

      let homePage = Vue.$routerCore?.GetHomePage() 

      // Выполнения проверки jsAction страницы
      await Promise.all(routesWithJSAction.map( async (el) => {
        const isPageDisabled = await Vue.$jsActionsRunner.callJsActions(el.Disabled.JsAction)

        // Если страница которую мы отключили, является домашней
        if (el.$ID === homePage.$ID) {
          throw new Error('error, attempt to disable homepage')
        }

        // Если страница не отключена, добавить в список всех страниц
        if (!isPageDisabled) {
          delete el.Disabled
          delete el.$ID
          correctRoutes.push(el)
        } else {
          // Сохранение отключённо страницы в стору, для дальнейшего удаления из navigation-drawer
          store.commit('setDisabledPageInList', el)
        }
      }))

      return correctRoutes
    }

    const routes = await getRoutes()
    router.addRoutes(routes)


    function setCurrentPage(targetPage, LayoutType, to) {
      // контекст открываемой страницы. передается при открытии страницы в to.context
      store.commit('setCurrentPageContext', { id: targetPage?.$ID, context: to.params?.context})

      store.commit('setCurrentPageParams', JSON.stringify({ query: to.query, params: to.params }))

      // добавить тайтл документа 
      document.title = `${store.state.appRunner.model.Name} - ${evaluatePageTitle(targetPage?.Name) || ''}`

      // Помещаем в state ID страницы для отображения, в зависимости от её типа
      if (LayoutType === 'responsive' || LayoutType === undefined) {
        store.commit('setCurrentPage', targetPage?.$ID || '')
      } else {
        store.commit('setCurrentPopPupPage', targetPage?.$ID || '')
      }
    }

    function mergePages(currentPages, userPages) {
      let newPages = new Array()
      currentPages.map(page => {
        page = { ...page, ...userPages.find( x => x.$ID === page.$ID)}
        newPages.push(page)
      })
      return newPages
    }

    function evaluatePageTitle(val) {
      const localeRegex = /\$t\((.*?)\)/gm
      return val.replace(localeRegex, (match, p1) => {
        let x = undefined
        return (x = i18n.t(p1)) === undefined ? match : x
      })
    }
    
    // Защита роутинга
    async function AuthGuard(to, from, next) {
      // если текущая страница popup, нужно просто ее закрыть и не менять роут
      // if (store.state.appRunner.currentPopPupPageId !== null) {
      //   store.commit('setCurrentPopPupPage', null)
      //   return next(false)
      // }
      // if (!to.name) { //TODO: сделать нормальную обработку
      //   return  next(to.path)
      // }
      // return next()

      // все страницы публичные и доступны анонимным пользователям
      if (!appModel.ProjectSecurity.NeedAuthentication) {
        return next()
      }
      
      await Vue.$authCore.updateUserData()
      const getTargetPageModel = function (to) {
        // в случае когда срабатывает редирект на старте, в pathMath хранится путь на который мы изначально должны были перейти
        if (to.params.pathMatch) {
          // обрезаем слеш пути из браузере
          const pageId = to.params.pathMatch.substring(1)
          return Vue.$routerCore?.GetPageById(pageId)
        }
        return Vue.$routerCore?.GetPageById(to.name)
      }    
      let targetPageModel = getTargetPageModel(to)
      // // определяем домашнюю страницу
      let homePage = Vue.$routerCore?.GetHomePage() 

      // Если страница, на которую осуществляется переход, не найдена - перенаправляем на домашнюю страницу
      if (!targetPageModel) {
        store.commit('setCurrentPage', homePage?.$ID)
        //  Если были заданы параметры, они передаются на домашнюю страницу
        return to.query ?  next( { name: homePage?.$ID, query: to.query } ) : next( { name: homePage?.$ID } )
      }

      let haveAccessToTargetPage = Vue.$routerCore?.HaveAccessToPage(targetPageModel)
      if (!haveAccessToTargetPage && Vue.$routerCore?.HaveAccessToPage(homePage)) {
        targetPageModel = homePage
        haveAccessToTargetPage = true
      }

      // Проверяем, что есть доступ к странице согласно роли
      if (haveAccessToTargetPage) {
        if (!targetPageModel.CheckAvailability) {
          // Проверяем, если страница типа popup, route не меняем, просто показываем диалог
          setCurrentPage(targetPageModel, targetPageModel.LayoutType, to)
          if (!targetPageModel.LayoutType || targetPageModel.LayoutType === 'responsive') {
            return to.name !== targetPageModel.$ID ? next( { name: targetPageModel.$ID, query: to.query } ) : next()
          }
          return next({ name: from.name, query: to.query })
        }

        // Обращаемся к бизнес логике
        const params = { modelId: Vue.$lifeCycleCore.store.getters.appModel.$ID, pageId: targetPageModel.$ID, routeQuery: to.query, routeParams: to.params }
        const hookResult = await Vue.$lifeCycleCore.CallBeforePageEnterHook(params)
        if (hookResult.result) {
          // Проверяем, если страница типа popup, route не меняем, просто показываем диалог
          setCurrentPage(targetPageModel, targetPageModel.LayoutType, to)
          if (!targetPageModel.LayoutType || targetPageModel.LayoutType === 'responsive') {
            return next()
          }
          return
        }
        // eslint-disable-next-line no-console
        console.error(`Route from ${from.name} to ${targetPageModel.$ID} is blocked, by hook: CallBeforePageEnter. HookResult: ${hookResult}`)
      } else {
        // eslint-disable-next-line no-console
        console.error(`User: ${Vue.$routerCore?.UserRole} doesn't have access to page: ${targetPageModel.$ID}.`)
      }
      let havePathParams = false

      if (from.name !== Vue.$routerCore?.GetSignInPage()?.Path || from.name !== Vue.$routerCore?.GetSignInPage()?.$ID) {
        havePathParams = true
      }
      // признак аутентификация пользователя
      let isAuthenticated = store.getters.isAuthenticated
      let oidcEnabled = store.getters.appModel.ProjectSecurity.OidcEnabled
      // если в приложение включен oidc и пользователь не аутентифицирован, тогда используем вход по oidc
      if (oidcEnabled && !isAuthenticated) {
        Vue.$authCore.auth.loginByOidc({lang: i18n.locale, returnUrl: window.location.href, prompt: 'default'})
      }

      // перебрасываем на страницу SignIn
      let signinPage = Vue.$routerCore?.GetSignInPage()
      let path = getPath(to, havePathParams)

      let signInRoute = { name: Vue.$routerCore?.GetSignInPage()?.$ID,
        ...( havePathParams && { query: { to: path } })
      }
      setCurrentPage(signinPage, signinPage?.LayoutType, to)
      return next(signInRoute)
    }       
    if (appModel.ProjectSecurity?.NeedAuthentication) {
      router.beforeEach(AuthGuard)
    }

    // формирование пути с get параметрами
    function getPath(to, havePathParams) {
      let path = ''

      if (!havePathParams) {
        return path
      }

      // Когда common-app-player запущен с установленным параметром window.application.uniqID,
      // и когда мы не авторизованы, то после переброса на loginPage в to.path - хранится некорректный путь.
      path = to.params?.pathMatch || to.path

      if (Object.keys(to.query).length) {
        let params = new URLSearchParams()
        for (let item in to.query) {
          params.append(item, to.query[item])
        }
        if (params.toString()) {
          path += `?${params.toString()}`
        }
      }
      return path
    }
  }
}
